// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-list > div {\n  width: 120px;\n  height: 30px;\n  background: #2395f3;\n  border-radius: 4px 4px 4px 4px;\n  font-family: Microsoft YaHei, Microsoft YaHei;\n  font-weight: 400;\n  font-size: 14px;\n  color: #ffffff;\n  cursor: pointer;\n}\n.btn-list > div + div {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
